/** The "Add link" section of the node inspector. */
import { For, createMemo, type JSX } from "solid-js";
import type { Node } from "@protocol/Node";
import { useApp } from "../../app/context";
import { byId } from "../../shared/analysis";
import { toast } from "../../shared/toast";

/** A form to add a link from this node: a kind and a target. */
export function NodeLinkForm(props: { node: () => Node }): JSX.Element {
  const n = props.node;
  const { actions, view, graph, kinds } = useApp();
  /** The whole graph. */
  const g = () => graph.state.graph;
  /** Every other node, by name. */
  const others = createMemo(() => g().nodes.filter((o) => o.id !== n().id).sort((a, b) => a.name.localeCompare(b.name)));
  let linkKind!: HTMLSelectElement;
  let linkTarget!: HTMLSelectElement;
  return (
    <>
      <section class="grp">
        <h3>Add link</h3>
        <p class="hint2">Or drag from the handle beside the node on the graph.</p>
        <div class="lform">
          <div class="row">
            <select class="select" aria-label="Link type" ref={linkKind}>
              <For each={kinds.links()}>{(k) => <option value={k.id}>{k.label}</option>}</For>
            </select>
            <select class="select" aria-label="Target node" ref={linkTarget}>
              <For each={others()}>{(o) => <option value={o.id}>{o.name}</option>}</For>
            </select>
          </div>
          <button
            type="button"
            class="btn"
            id="add-link"
            onClick={() => {
              const kind = kinds.links().find((k) => k.id === linkKind.value);
              const to = linkTarget.value;
              if (!kind) return;
              if (!to) return toast("Choose a target node.");
              const made = kinds.toDefine([], [kind.id]).length ? kinds.addLink({ from: n().id, to, kind: kind.id, label: "" }) : actions.addLink(n().id, kind.id, to);
              void made.then((ok) => {
                if (!ok) return;
                view.showLinkKind(kind.id);
                toast(`${n().name} ${kind.verb} ${byId(g()).get(to)?.name ?? to}.`);
              });
            }}
          >
            Add link from {n().name}
          </button>
        </div>
      </section>
    </>
  );
}
